export const defaultError =
    "Sorry, we're experiencing an issue with this service and are working to resolve it as soon as possible. Please try again later.";

export const errorList = [
    {
        system: "Firstname cannot be empty",
        friendly: "You must add your first name here"
    },
    {
        system: "An account with the given phone_number already exists",
        friendly:
            "The phone number you’ve entered has recently been used. If your details are correct, please try again in 30 minutes."
    },
    {
        system: "An account with the given email already exists",
        friendly:
            "The email address you’ve entered has recently been used. If your details are correct, please try again in 30 minutes."
    },
    {
        system: "Phone number is invalid",
        friendly: "Looks like this is not a correct phone number"
    },
    {
        system: "Code cannot be empty",
        friendly: "Please add your 6-digit code here"
    },
    {
        system: "Invalid verification code, please try again",
        friendly: "That's not a valid code. Please try again."
    },
    {
        system: "Invalid code provided, please request a code again.",
        friendly: "That's not a valid code. Please request a new one."
    },
    {
        system: "Validation error detected",
        friendly:
            "That doesn't look quite right. If you have included any spaces or letters, remove these and try again."
    },
    {
        system: "validation error detected",
        friendly:
            "That doesn't look quite right. If you have included any non-numeric characters or spaces, remove these and try again. "
    },
    {
        system: "Spaces allowed but validation error detected",
        friendly:
            "That doesn't look quite right. If you have included any non-numeric characters, remove these and try again."
    },
    {
        system: "Invalid phone number provided/Unable to send the message",
        friendly: "Looks like this is not a correct phone number"
    },
    {
        system: "Attempt limit exceeded, please try after some time.",
        friendly:
            "You've exceeded the number of new code requests for now. Please try again in 30 minutes."
    },
    {
        system: "User does not exist",
        friendly:
            "Your application cannot be completed now. Please try again after 30 minutes."
    },
    {
        system: "Invalid verification code provided, please try again",
        friendly: "That's not a valid code. Please try again."
    },
    {
        system: "Username or password is incorrect",
        friendly: "That name or password is not valid"
    },
    {
        system: "User cannot be confirmed. Current status is CONFIRMED",
        friendly:
            "Your application cannot be completed now. Please try again after 30 minutes."
    },
    {
        system: "Username/client id combination not found",
        friendly:
            "Your application cannot be completed now. Please try again after 30 minutes."
    },
    {
        system: "User is already confirmed",
        friendly:
            "Your application cannot be completed now. Please try again after 30 minutes."
    },

    {
        system: "Invalid phone number format",
        friendly: "Looks like this is not a correct phone number"
    },
    {
        system: "Unable to load session",
        friendly:
            "The details you've entered have already been used for this application. If your details are correct, please try again after 30 minutes."
    },
    {
        system: "Invalid email address",
        friendly: "Invalid email address"
    },
    {
        system: "Exceeded daily email limit for the operation or the account",
        friendly: defaultError
    },
    {
        system: "PreSignup failed",
        friendly: defaultError
    }
];
